import fp from 'lodash/fp';

const Instagram = ({
  graphql: {
    user: {
      edgeOwnerToTimelineMedia: {
        edges,
        pageInfo,
        ...edgeOwnerToTimelineMedia
      },
      ...user
    },
    ...graphql
  },
  ...instagram
}) => ({
  ...instagram,
  graphql: {
    user: {
      ...user,
      edgeOwnerToTimelineMedia: {
        ...edgeOwnerToTimelineMedia,
        edges: fp.map(({
          node,
          ...edge
        }) => ({
          node,
          ...edge,
          __typename: 'InstagramMediaEdge'
        }))(edges),
        pageInfo: {
          ...pageInfo,
          __typename: 'InstagramMediaPageInfo'
        },
        __typename: 'InstagramMedia'
      },
      __typename: 'InstagramUser'
    },
    __typename: 'InstagramGraphql'
  },
  __typename: 'Instagram'
});

export default Instagram;



// WEBPACK FOOTER //
// ./src/type-patchers/instagram.js